<template>
  <div class="star">
    <img class="img" :key="name + '-full-' + index" v-for="(item,index) in num" src="@/assets/travelAgency/ic_pingfen@2x.png">
    <img class="img" :key="name + index" v-for="(item,index) in 5-num" src="@/assets/travelAgency/ic_pingfenhui@2x.png">
  </div>
</template>
<script>
    export default {
        components: {},
        props: {
            num: {
                type: Number,
                default: 0
            },
            name: {
                type: String,
                default: ''
            }

        },
        data () {
            return {

            }
        },
        computed: {

        },
        methods: {

        },
        mounted () {

        }

    }
</script>

<style scoped lang="less">
@vv: 3.75vw;
  .star {
    display: flex;
    align-items: center;
    height: 16/@vv;

    .img {
      margin-right: 2/@vv;
      width: 8/@vv;
      height: 8/@vv;
    }
  }
</style>
